import {Autocomplete, Box, createFilterOptions, TextField} from "@mui/material";
import React from "react";
import {PersonApiGet, useGetPersonQuery} from "./people_api";
import {MultiSearchProps} from "../../components/SearchBox";
import {Tables} from "../../apitypes";
import AvatarImage from "../storage/AvatarImage";


export default ({onChange, value}: MultiSearchProps<Tables<"worker">>) => {

    const {data} = useGetPersonQuery({});

    return <Autocomplete
        id={"PersonApiGet"}
        multiple
        options={data || []}
        autoHighlight
        sx={{minWidth: "200px", flex:1}}
        value={value}
        onChange={(e, v: PersonApiGet[]) => onChange(v)}
        getOptionLabel={(option: PersonApiGet) => {
            return option.lastName + " " + option.firstName;
        }}
        filterOptions={createFilterOptions({
            stringify: (option) => option.lastName + " " + option.firstName,
        })}
        renderOption={(props, option: PersonApiGet) => {
            const {key, ...rest} = props
            return <Box key={key} component="li" sx={{'& > .MuiAvatar-root': {mr: 1}}} {...rest}>
                <AvatarImage image_url={option.avatar_url} bucket={"avatars"}/> {option.lastName} {option.firstName}
            </Box>
        }}
        renderInput={(params) => (
            <TextField
                {...params}
                sx={{minWidth: "150px"}}
                label="Delavec"
                variant={"standard"}
            />
        )}
    />

}
